import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledLabel, CheckboxIcon } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { capitalize } from "@helpers/general";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import { mutate } from "swr";

import { setGlobalDataIsUpdated, store as localStore } from "../store";
import { store } from "@components/VerticalLayout/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type ConfirmationModificationMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setIsEdited: Function;
    setDataIsUpdated: Function;
    dataFidelity: any;
    associated: any[];
    isAddFiscalYearClicked: boolean;
    setIsAddFiscalYearClicked: Function;
    setIsValidateButtonEnabled: Function;
};

export function ConfirmationModificationMessage({
    isModalOpened,
    setIsModalOpened,
    setIsEdited,
    setDataIsUpdated,
    dataFidelity,
    associated,
    isAddFiscalYearClicked,
    setIsAddFiscalYearClicked,
    setIsValidateButtonEnabled,
}: ConfirmationModificationMessageType) {
    const { t } = useTranslation();

    const { userID, franchiseID, operatorID } = useSnapshot(store);
    const { globalDataIsUpdated } = useSnapshot(localStore);

    const [error, setError] = React.useState<boolean>(false);
    const uuidUser = localStorage.getItem("uuidUser");

    async function editFidelity() {
        toast.dismiss();
        let objectData = {};
        let localData: any[] = [];

        associated.forEach(async (el: any) => {
            Object.assign(objectData, {
                [el.Id]: {
                    designation: dataFidelity.data[el.Id].designation,
                    type: dataFidelity.data[el.Id].type,
                    number_fidelity_points: el.number_fidelity_points,
                    money_correspondence: el.money_correspondence,
                    devise: el.devise,
                    pays: el.pays,
                    authentication_mode: el.authentication_mode,
                    sortedVisibility: el.sortedVisibility,
                    Login: el.Login,
                    password: el[t("Password")],
                    note: dataFidelity.data[el.Id].note,
                    isActive: el.isActive,
                    isArchived: el.isArchived,
                    shopId: el.shopId,
                    dashboardLink: el[t("Dashboard Link")],
                    user: el.user,
                    apiKey: el["API key"],
                    auresKonnectGroup: el.auresKonnectGroup,
                    isCentralizationActive: el.isCentralizationActive,
                    isVisibiliteActive: el.isVisibiliteActive,
                    fidelityChoiceIndex: el.fidelityChoiceIndex,
                },
            });

            let dataOfFidelity = {
                userId: userID,
                shopId: [el.shopId],
                franchiseId: franchiseID,
                operatorId: operatorID,
                uuidUser: uuidUser,
                data: objectData,
                isShop: true,
                isAssociate: true,
            };

            localData.push(
                fetch(
                    `${process.env.REACT_APP_API_V2_URL}/settings/general/fidelity`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(dataOfFidelity),
                    }
                ).then((response) => response.json())
            );
        });
        try {
            mutate(
                `${process.env.REACT_APP_API_V2_URL}/settings/general/fidelity`,
                await Promise.all(localData).then((result) => {
                    result.forEach((element: any) => {
                        if (element.error === true) setError(true);
                    });
                })
            );
        } catch (e) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }

        if (error === false) {
            toast.success(
                `${t("The fidelity of shop  was successfully changed")!}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    theme: "colored",
                    icon: <CheckboxIcon height={25} width={25} fill="white" />,
                }
            );
        }
        setTimeout(() => {
            setGlobalDataIsUpdated(!globalDataIsUpdated);
            setDataIsUpdated(true);
            setIsAddFiscalYearClicked(!isAddFiscalYearClicked);
            setIsEdited(false);
        }, 2000);
    }

    function close() {
        setIsModalOpened(!isModalOpened);
        setIsAddFiscalYearClicked(false);
        setIsValidateButtonEnabled(true);
        setIsEdited(false);
    }

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader className="text-capitalize" toggle={close}>
                <span
                    style={{
                        fontFamily: "Segoe UI Semibold",
                        color: "#2b2828",
                        fontSize: "20px",
                    }}
                >
                    {capitalize(t("Alert"))}
                </span>
            </ModalHeader>
            <ModalBody>
                <StyledLabel
                    className="pl-3 m-0"
                    style={{ whiteSpace: "pre-line" }}
                >
                    {t(
                        'Do you want to apply these changes for all stores? \n Attention ! If you click on "Validate", the specific settings of the shops will be modified.'
                    )}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={close}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsModalOpened(!isModalOpened);
                        editFidelity();
                        setGlobalDataIsUpdated(!globalDataIsUpdated);
                        setIsAddFiscalYearClicked(false);
                        setIsValidateButtonEnabled(true);
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
